module.exports = __webpack_public_path__ + "img/重庆南川黎香湖国家湿地公园@2x.62034c37.png";